import styled from 'styled-components'
import COLORS from '../../../colors/colors'

export const StyledFooter = styled.div`
    text-align: center;
    margin-bottom: 1rem;
    color: ${COLORS.lightGray};
    `